/* eslint-disable import/no-extraneous-dependencies */
import { withStyles } from '@mui/styles';

import CreatePledgeForm from './CreatePledgeForm';
import muiStyles from './styles';

export default withStyles(muiStyles)(CreatePledgeForm);